import { crudEndpointsFactory } from "../crud-endpoints.factory";
import { IPromotion } from "@app/common";

const url = 'promotions';
const tagType = 'Promotions';

export const promotionApi = crudEndpointsFactory<IPromotion>()('promotions', 'Promotions').injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => {
    return {
      createOnePromotions: builder.mutation<IPromotion, FormData>({
        invalidatesTags: [{ type: tagType, id: 'LIST' }],
        query: (body) => ({
          url,
          method: 'POST',
          body,
        }),
      }),
      updateOnePromotions: builder.mutation<Partial<IPromotion>, { _id: string, formData: FormData }>({
        invalidatesTags: (_, __, arg) => [{ type: tagType, id: arg._id }],
        query: ({ _id, formData }) => ({
          url: `${url}/${_id}`,
          method: 'PUT',
          body: formData,
        }),
      }),
    }
  },
});
